import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import editIco from '../../assets/images/icons/ico-edit.svg';

import TextField from '../common/TextField';
import FileField from '../common/FileField';

const fileSelect = (value) => (value ? undefined : 'You forgot to choose files');
const required = (value) => (value && value !== '' ? undefined : 'Required');

function TagForm(props) {
  const { handleSubmit, pristine, submitting, closeDialog, initialValues } = props;
  const [isEditThumb, setIsEditThumb] = useState(false);

  const handleEditThumb = () => {
    setIsEditThumb(!isEditThumb);
  };

  return (
    <form onSubmit={handleSubmit} className="customForm addMembership meditation">
      <div>
        <Field
          name="name"
          component={TextField}
          label="Tag"
          placeholder="Enter Tag"
          validate={required}
        />
      </div>
      {!initialValues || isEditThumb ? (
        <div>
          <Field
            name="fileLocation"
            component={FileField}
            label="Image"
            validate={fileSelect}
            disabled={false}
          />
        </div>
      ) : null}
      {initialValues && !isEditThumb ? (
        <div className="file-wrapper">
          <div className="edit-ico" role="presentation" onClick={handleEditThumb}>
            <img src={editIco} alt="" />
          </div>
          <img
            src={`https://public-prod.retreatsounds.com/${initialValues.fileLocation}`}
            className="smallicon"
            alt=""
          />
        </div>
      ) : null}
      <div className="text-right">
        <button type="button" onClick={closeDialog} className="submit-button cancel-button">
          Cancel
        </button>
        <button type="submit" className="submit-button" disabled={pristine || submitting}>
          Update
        </button>
      </div>
    </form>
  );
}

TagForm.propTypes = {
  initialValues: PropTypes.shape({
    fileLocation: PropTypes.any,
  }),
  closeDialog: PropTypes.func,
  handleSubmit: PropTypes.func,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
};

TagForm.defaultProps = {
  initialValues: undefined,
  closeDialog: undefined,
  handleSubmit: undefined,
  pristine: undefined,
  submitting: undefined,
};

export default reduxForm({
  form: 'addTag',
})(TagForm);
